// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../ui-login/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".c-typed-message{display:flex;letter-spacing:0.02em;font-size:14px;font-weight:500}.c-typed-message--warning{color:#a36127}.c-typed-message--success{color:#347f4d}.c-typed-message--info{color:#285ffa}.c-typed-message--error{color:#c92f24}.c-typed-message--neutral{color:#ffffff}.c-typed-message__icon{display:flex;align-items:center;margin-right:10px}\n", ""]);
// Exports
module.exports = exports;
